import { createSlice } from "@reduxjs/toolkit";
import { EsicReasonState } from "./reasonTypes";
import {createEsicReason,fetchEsicReasonList,fetchEsicReasonById,updateEsicReason,deleteEsicReason} from "./ReasonAction";

const initialState: EsicReasonState = {
  list: [],
  selected: null,
  loading: false,
  error: null,
};

const esicReasonSlice = createSlice({
  name: "esicReason",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Create
    builder.addCase(createEsicReason.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createEsicReason.fulfilled, (state, action) => {
      state.loading = false;
      state.list.push({
        reason_id: action.payload.id,
        reason_type: "",
        reason_text: "",
      });
    });
    builder.addCase(createEsicReason.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Get All
    builder.addCase(fetchEsicReasonList.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchEsicReasonList.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    });
    builder.addCase(fetchEsicReasonList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Get By Id
    builder.addCase(fetchEsicReasonById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchEsicReasonById.fulfilled, (state, action) => {
      state.loading = false;
      state.selected = action.payload;
    });
    builder.addCase(fetchEsicReasonById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Update
    builder.addCase(updateEsicReason.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateEsicReason.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateEsicReason.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Delete
    builder.addCase(deleteEsicReason.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteEsicReason.fulfilled, (state, action) => {
      state.loading = false;
      state.list = state.list.filter(
        (item) => item.reason_id !== (action.meta.arg as number)
      );
    });
    builder.addCase(deleteEsicReason.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export default esicReasonSlice.reducer;
